import React, { useState, useEffect } from "react";
import { usd, StaticNote } from "./ui";
import { captureReport, fetchReports, fetchReportBlob } from "../api";
import "./Dashboard.css";

export default function MonthlyReports({ data, ctx }) {
  const [reports, setReports] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const load = () => fetchReports(ctx).then((r) => setReports(r.reports || [])).catch((e) => setErr(e.message));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCapture = async () => {
    setBusy(true); setErr(null); setMsg(null);
    try {
      const res = await captureReport(ctx, data?.month);
      setMsg(`Saved ${res.report.monthLabel} final report.`);
      await load();
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const openPdf = async (month, download) => {
    try {
      const blob = await fetchReportBlob(ctx, month);
      const url = URL.createObjectURL(blob);
      if (download) {
        const a = document.createElement("a");
        a.href = url; a.download = `NursePartners-${month}-final.pdf`; a.click();
      } else {
        window.open(url, "_blank");
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { setErr(e.message); }
  };

  return (
    <div className="dash">
      <section className="panel">
        <div className="panel-head">
          <h2>Monthly Reports Archive</h2>
          {data?.monthLabel && (
            <button className="btn btn-refresh" onClick={onCapture} disabled={busy || data?.empty}>
              {busy ? "Saving…" : `Save ${data.monthLabel} as final report`}
            </button>
          )}
        </div>
        {msg && <div className="upload-msg">✓ {msg}</div>}
        {err && <div className="state error">{err}</div>}
        <p className="muted" style={{ fontSize: 13, margin: "4px 0 14px" }}>
          Captures a PDF of the month across all tabs (Executive/EBITDA omitted). Re-capturing a month replaces its PDF.
        </p>

        {!reports && <div className="state">Loading…</div>}
        {reports && reports.length === 0 && <div className="state">No reports captured yet. Load a month and click "Save as final report".</div>}
        {reports && reports.length > 0 && (
          <table className="grid">
            <thead><tr><th>Month</th><th>Captured</th><th>Report date</th><th>Forecast</th><th>PDF</th></tr></thead>
            <tbody>
              {reports.map((r) => (
                <tr key={r.month}>
                  <td className="rowhead">{r.monthLabel}</td>
                  <td>{new Date(r.capturedAt).toLocaleString()}</td>
                  <td>{r.reportDate || "—"}</td>
                  <td className="strong">{usd(r.forecast)}</td>
                  <td>
                    <button className="link-btn" onClick={() => openPdf(r.month, false)}>View</button>
                    <span className="sep">·</span>
                    <button className="link-btn" onClick={() => openPdf(r.month, true)}>Download</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      <StaticNote>Reports are stored on the server so you can compare months over time. They persist across deploys once the Railway volume is attached.</StaticNote>
    </div>
  );
}
